/* eslint-disable no-console */

export const printHelloConsoleBanner = () => {
  console.log(`
                                  ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
        ██████                  ▒▒                    ▒▒▒                       
    ██▒▒▒▒▒▒██                ▒▒                        ▒▒                     
  ██▒▒▒▒▒▒▒▒▒▒██              ▒▒    ██    ██      ██    ▒▒                     
██▒▒▒▒▒▒▒▒▒▒▒▒▒▒██            ▒▒    ██    ██  ██  ██    ▒▒                     
██████▒▒▒▒██▒▒▒▒██            ▒▒    ████████      ██    ▒▒                     
██▒▒▒▒██▒▒▒▒▒▒▒▒▒▒██        ▒▒      ██    ██  ██        ▒▒                     
██▒▒▒▒██▒▒▒▒▒▒▒▒▒▒██      ▒▒        ██    ██  ██  ██    ▒▒                     
  ██▒▒██▒▒▒▒▒▒▒▒▒▒██    ▒▒                              ▒▒                     
  ██▒▒██▒▒▒▒▒▒▒▒▒▒▒▒██    ▒▒▒▒▒▒▒▒                    ▒▒                     
    ██▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒██            ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒          
    ██▒▒▒▒██▒▒▒▒▒▒▒▒▒▒▒▒██                    
    ██▒▒▒▒██▒▒▒▒░░▒▒░░▒▒██                    
    ██▒▒▒▒██▒▒░░░░░░▒▒░░▒▒██                  
      ██▒▒▒▒██░░░░░░░░░░░░██                  
      ██▒▒▒▒██▒▒░░▒▒▒▒░░▒▒░░██                
        ██▒▒▒▒██▒▒░░▒▒▒▒░░▒▒██                
        ░░██▒▒▓▓▓▓▒▒░░▒▒░░▒▒▒▒██              
            ██▒▒▒▒████░░▒▒░░▒▒██              
              ██████▒▒██░░░░▒▒▒▒██            
        ██████▒▒██▒▒██▓▓████░░▒▒██            
        ██▓▓▓▓████████▓▓▓▓▓▓██░░▒▒██          
        ██▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓██▒▒░░░░██        
            ████▓▓▓▓▓▓▓▓▓▓██░░▒▒░░▒▒██      
                ██▓▓▓▓▓▓▓▓▓▓██░░░░▒▒░░▒▒██    
                ██▓▓▓             ▒▒▒▒▒▒▒▒▒▒██  
                ██▓▓▓                     ▒▒██
                ██▓▓▓                          ██  
`);
  // From personal experience... I know that this can intiate
  // conversations that will provide us with valuable feedback
  // about how developers want to engage with our website in an
  // automated way, etc.
  //
  // The purpose of this message is to gather feedback from people
  // trying to scrape our website or otherwise interact with our
  // platform in non-standard ways.
  console.log('Hi! What do? (CTO email: gajus@contra.com)');
};
